import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter, forwardRef, OnDestroy } from '@angular/core';
import Quill from 'quill';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-rich-text-editor',
    templateUrl: './rich-text-editor.component.html',
    styleUrls: ['./rich-text-editor.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RichTextEditorComponent),
            multi: true
        }],
    standalone: false
})
export class RichTextEditorComponent implements OnInit, AfterViewInit, ControlValueAccessor, OnDestroy {

  constructor() {}

  @ViewChild('editor', { static: false }) editorElement!: ElementRef;

  @Input() placeholder = 'Inserisci il testo qui...';
  @Input() disabled = false;
  @Input() isPreview = false;

  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();

  private innerValue = '';

  public quill!: Quill;
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.initializeQuill();
  }

  private initializeQuill(): void {
    const toolbarOptions = [
      [{ font: [] }],
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ align: [] }],
      ['link', 'image', 'video'],
      ['clean']
    ];

    this.quill = new Quill(this.editorElement.nativeElement, {
      theme: 'snow',
      placeholder: this.placeholder,
      readOnly: this.isPreview || this.disabled,
      modules: {
        toolbar: this.isPreview ? false : toolbarOptions
      }
    });

    // Imposta il valore iniziale, se presente
    if (this.innerValue) {
      this.quill.root.innerHTML = this.innerValue;
      this.syncBlankState();
    }

    if (!this.isPreview) {
      this.quill.on('text-change', (delta, oldDelta, source) => {
        // Aggiorna il modello solo se il cambiamento proviene dall'utente
        if (source === 'user') {
          const html = this.quill.root.innerHTML;
          this.innerValue = html;
          this.onChange(html);
          this.onTouched();
          this.modelChange.emit(html);
        }
      });
    }
  }



  writeValue(value: string): void {
    this.innerValue = value || '';
    if (this.quill) {
      const range = this.quill.getSelection();
      this.quill.root.innerHTML = this.innerValue;
      this.syncBlankState();
      if (range) {
        this.quill.setSelection(range);
      }
    }
  }

  private syncBlankState(): void {
    const root = this.quill.root;
    const hasText = (root.textContent ?? '').trim().length > 0;
    const hasEmbed = !!root.querySelector('img, iframe, video');
    root.classList.toggle('ql-blank', !hasText && !hasEmbed);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (this.quill) {
      this.quill.enable(!(this.disabled || this.isPreview));
    }
  }

  ngOnDestroy(): void {
  }
}
